export const SHIP_TO_SPECIAL_PRICES_FORM_MODAL = "SHIP_TO_SPECIAL_FORM_PRICES";
export const SHIP_TO_SPECIAL_PRICES_ATTACHMENT_MODAL = "SHIP_TO_SPECIAL_PRICES_ATTACHMENT";
